const OTCMap = {
	AP_SCREEN:  [
		'Our own sunscreen, designed for sensitive and acne-prone skin. ',
		'Complements prescription treatments. ',
	],
	RX_KIT: {
		description: '',
		descriptionLong: '',
		size: '2oz (3 month supply)',
		points: [],
		imgSrc: 'https://assets.apostrophe.com/img/newCheckout/kit_image_small.png',
	},
};

const IDtoNameMap = {
	APS001: 'AP_SCREEN',
}

export {
	IDtoNameMap,
	OTCMap,
};
